import {
    GET_SITE_PHOTOS_REQUEST,
    GET_SITE_PHOTOS_SUCCESS,
    GET_SITE_PHOTOS_FAILURE,
    CLEAR_SITE_PHOTOS,
    UPLOAD_INSTALLATION_PHOTO_REQUEST,
    UPLOAD_INSTALLATION_PHOTO_SUCCESS,
    UPLOAD_INSTALLATION_PHOTO_FAILURE,
    DELETE_INSTALLATION_PHOTO_REQUEST,
    DELETE_INSTALLATION_PHOTO_SUCCESS,
    DELETE_INSTALLATION_PHOTO_FAILURE,
} from "../actions/photos";

const initialState = {
    loading: false,
    error: null,
    list: [],
};

export default function photos(state = initialState, action) {
    switch (action.type) {
        case GET_SITE_PHOTOS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_SITE_PHOTOS_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.payload,
                error: null,
            };
        case GET_SITE_PHOTOS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case UPLOAD_INSTALLATION_PHOTO_REQUEST:
        case DELETE_INSTALLATION_PHOTO_REQUEST: {
            return {
                ...state,
                loading: true,
            };
        }

        case UPLOAD_INSTALLATION_PHOTO_SUCCESS:
        case UPLOAD_INSTALLATION_PHOTO_FAILURE:
        case DELETE_INSTALLATION_PHOTO_SUCCESS:
        case DELETE_INSTALLATION_PHOTO_FAILURE: {
            return {
                ...state,
                loading: false,
            };
        }

        case CLEAR_SITE_PHOTOS:
            return {
                ...initialState,
            };
        default:
            return state;
    }
}
